import ComponentsFactory from 'foundation/components-factory';
import OneClubButton from './js/one-club-button.component';

ComponentsFactory.getInstance().define('one-club-button', OneClubButton);
